import {
  LAYOUT_LIST,
  TEXT,
  ACCORDION,
  ACCORDION_ITEM,
  LayoutListDefinition
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';

export const Interactive1: Translator = sequence => {
  const columns = {
    type: LAYOUT_LIST,
    id: `${sequence.id}-columns`,
    items: [],
    values: {
      align: 'center',
      height: '100%',
      padded: false
    }
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'List':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center',
            height: '100%'
          },
          items: [
            CardHelper(
              {
                title: item.title,
                subtitle: item.subtitle,
                icon: item?.icon,
                id: `${item.id}_title`
              } as ItemOfType<'Card'>,
              {
                height: 'unset',
                width: { _: '95%', md: '70%' },
                padding: { _: '0px', md: '24px' },
                extraItems: [
                  {
                    type: ACCORDION,
                    id: item.id,
                    items:
                      item?.items?.map(item => {
                        return {
                          type: ACCORDION_ITEM,
                          id: item.id,
                          values: {
                            id: `${item.title}_title`,
                            value: item.title
                          },
                          items: [
                            {
                              type: TEXT,
                              id: `${item.id}_body`,
                              items: [],
                              values: {
                                value: item.body
                              }
                            }
                          ]
                        };
                      }) || [],
                    values: void 0
                  }
                ]
              }
            )
          ]
        };
      default:
        return null;
    }
  });

  root.items.push(columns);
  return root;
};
